import type { Editor } from '@tiptap/core';
import { useMarkHover } from './use-mark-hover.js';

type Comment = {
  id: string;
  documentId: string;
  userId: string;
  userEmail?: string;
  content: string;
  fromPos: number;
  toPos: number;
  selectedText: string;
  createdAt: string;
  updatedAt: string;
};

type UseCommentHoverReturn = {
  hoveredCommentId: string | null;
  hoveredComment: Comment | null;
  hoveredCommentPosition: { top: number; left: number } | null;
  commentHoverCardContentRef: React.RefObject<HTMLDivElement>;
  setHoveredComment: (comment: Comment | null) => void;
  closeCommentHover: () => void;
  setKeepCommentHoverOpen: (keepOpen: boolean) => void;
  onCommentHoverCardMouseEnter: () => void;
  onCommentHoverCardMouseLeave: () => void;
};

export const useCommentHover = (
  editor: Editor | null,
  comments: Comment[],
  isMobile: boolean
): UseCommentHoverReturn => {
  const {
    hoveredId,
    hoveredItem,
    hoveredPosition,
    hoverCardContentRef,
    setHoveredItem,
    closeHover,
    setKeepOpen,
    onHoverCardMouseEnter,
    onHoverCardMouseLeave,
  } = useMarkHover({
    editor,
    items: comments,
    markDataAttribute: 'data-comment-id',
    isMobile,
  });

  return {
    hoveredCommentId: hoveredId,
    hoveredComment: hoveredItem,
    hoveredCommentPosition: hoveredPosition,
    commentHoverCardContentRef: hoverCardContentRef,
    setHoveredComment: setHoveredItem,
    closeCommentHover: closeHover,
    setKeepCommentHoverOpen: setKeepOpen,
    onCommentHoverCardMouseEnter: onHoverCardMouseEnter,
    onCommentHoverCardMouseLeave: onHoverCardMouseLeave,
  };
};
